// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"87e46d9b","157":"8dc55662","334":"d7c4a870","722":"aaafd358"}[chunkId] + ".chunk.js";
};